import { Dispatch } from 'react';
import { ISprintWords, wordsResponse } from '../../../textbook/types';
import { SprintAction, SprintActionTypes } from '../type';
import { getWords } from '../../../textbook/api/fetchWords';
import { fetchUserWords } from '../../../textbook/store/action-creators';
import { getUserWords } from '../../../textbook/api/fetchUserWords';
import { createPageLoop } from '../../../game-audio/store/action-creators/gameAudio';

export const adaptToLocalSprintWords = (words: ISprintWords[]) =>
  words.map((word, i) => ({
    ...word,
    wrongTranslate: words[(i + 1) % words.length].wordTranslate,
    choice: Math.round(Math.random()),
  }));

export const getRandomNumbers = (quantity: number, min: number, max: number) => {
  const result = new Set();
  const range = max - min;

  while (result.size < quantity) {
    const random = Math.floor(Math.random() * range);
    const curr = min + random;
    if (!result.has(curr)) result.add(curr);
  }

  return Array.from(result);
};
export const fetchGroupWords = (group: number) => async (dispatch: Dispatch<SprintAction>) => {
  const dataPromises = getRandomNumbers(15, 0, 29).map((value) => getWords(Number(value), group));

  const data = await Promise.allSettled(dataPromises);
  const words = data
    .map((item) => (item.status === 'fulfilled' ? item.value : null))
    .filter((value) => value)
    .flat();
  const sprintWords = adaptToLocalSprintWords(words);
  dispatch({ type: SprintActionTypes.FETCH_SPRINT_WORDS, payload: sprintWords });
};
export const createPagesFilter = (group: number, quantity: number, min: number, max: number) => {
  const arr = getRandomNumbers(quantity, min, max);
  const res = arr.map((val) => ({ group, page: val }));

  return res;
};

export const fetchGroupUsersWords = (userId: string, group: number) => {
  return async (dispatch: Dispatch<SprintAction>) => {
    const filterPages = createPagesFilter(+group, 15, 0, 29);
    const filter = { $or: filterPages };
    const stringifyFilter = JSON.stringify(filter);
    try {
      await getUserWords(userId, stringifyFilter, `${600}`).then((data) => {
        const sprintWords = adaptToLocalSprintWords(data);
        dispatch({ type: SprintActionTypes.FETCH_SPRINT_WORDS, payload: sprintWords });
      });
    } catch (e) {}
  };
};

export const fetchFilteredUsersWordsSprint = (userId: string, group: number, page: number) => {
  return async (dispatch: Dispatch<SprintAction>) => {
    try {
      const pageNumber = +page;
      const pageLoop = createPageLoop(pageNumber);
      const perPage = 20;
      let count = 0;
      const getWords = async (pageNum: number, perPage: number) => {
        const filter = {
          $and: [
            { group: +group, page: pageNum },
            { $or: [{ 'userWord.optional.learned': false }, { userWord: null }] },
          ],
        };
        const stringifyFilter = JSON.stringify(filter);
        const words = await getUserWords(
          userId,
          `{"$and":[{"group": ${group}, "page": ${page}}]}`,
          `${perPage}`
        );
        const sprintWords = adaptToLocalSprintWords(words);
        dispatch({ type: SprintActionTypes.UPDATE_WORDS_SPRINT, payload: sprintWords });
        count += 1;
        perPage -= sprintWords.length;
        if (count >= pageLoop.length || perPage <= 0) return;
        await getWords(pageLoop[count], perPage);
      };
      await getWords(pageLoop[count], perPage);
    } catch (e) {}
  };
};
export const updateGroupSprint = (id: number) => (dispatch: Dispatch<SprintAction>) => {
  return dispatch({ type: SprintActionTypes.UPDATE_GROUP, payload: id });
};

export function removeWordsSprint(): SprintAction {
  return { type: SprintActionTypes.REMOVE_WORDS };
}
